import ShippingLanesSetType from "./ShippingLanesSetType";

const ShippingLanesSetTypeData = {
	[ShippingLanesSetType.SHIPPING]: {
		name: "Shipping Lanes",
		defaultColor: [1.0, 0.0, 0.0, 1.0],
		ais_data_type: "global"
	},
	[ShippingLanesSetType.FISHING]: {
		name: "Fishing Lanes",
		defaultColor: [0.0, 0.0, 1.0, 1.0],
		ais_data_type: "global",
		filters: {
			ship_type: "Fishing"
		}
	},
	[ShippingLanesSetType.TRAWLING]: {
		name: "Fishing Lanes (Trawlers)",
		defaultColor: [0.0, 1.0, 1.0, 1.0],
		ais_data_type: "trawling"

	},
	[ShippingLanesSetType.DARK]: {
		name: "Dark Shipping Lanes",
		defaultColor: [0.0, 0.0, 0.0, 1.0],
		ais_data_type: "aisoff"
	}
};
export default ShippingLanesSetTypeData;
